/*
|--------------------------------------------------------------------------
| Views: Most Popular Widget
|--------------------------------------------------------------------------
*/

/**
 * Most Popular Widget View
 * @namespace
 */
__gh__webApp.views.mostPopularWidget = {

	"callbacks": function(bucket){
		__gh__webApp.utilities.slider.loadAllSliders();
	},


	"getSubView": function(bucket){
		var sliderSettings	= this.getSliderSettings();
		bucket.view.sliderSettings 	= sliderSettings;
		return bucket;
	},


	"getSliderSettings":function(){
		var sliderSettings = {
			"rows":4,
			"slidesPerRow":1,
			"adaptiveHeight":true,
			"dots":true,
			"arrows":false
		};
		
		return sliderSettings;
	}

};
